import { create } from 'zustand';
import { logger } from '@shared/logger';

type TOverlayStore = {
    overlayOpen: boolean;
    zIndex: number;
    onClose: () => void;
    setOverlayState: (value: boolean, closeAction?: () => void, zIndex?: number) => void;
};

const useOverlayStore = create<TOverlayStore>((set, get) => ({
    overlayOpen: false,
    zIndex: 10,
    onClose: () => {},
    setOverlayState: (value, closeAction, zIndex = 10) => {
        logger.log('OverlayState', 3, value);
        // if value is true then call the old onClose function to close the overlay
        if (!value) {
            // check if onClose is a function
            typeof get().onClose === 'function' && get().onClose();
        }

        set({ overlayOpen: value, onClose: closeAction, zIndex });
    },
}));

export default useOverlayStore;
